import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdcContract } from "../../utils/contractHelpers";
import { useWeb3React } from "../useWagmiCompat";
import Environment from "../../utils/Environment";
import Web3 from "web3";

const BalacefAccountUsdc = () => {
  const { account } = useWeb3React();
  // const web3 = useWeb3();
  const web3 = new Web3(Environment.rpc);
  const tokenAddress1 = Environment.usdc;
  const contract = usdcContract(tokenAddress1, web3);
  const balacefAccountUsdc = useCallback(async () => {
    try {
      const buy = await contract.methods.balanceOf(account).call();
      return buy / 10 ** 6;
    } catch (error) {
      throw error;
    }
  }, [contract, account]);
  return { balacefAccountUsdc: balacefAccountUsdc };
};
export default BalacefAccountUsdc;
